export default __webpack_public_path__ + "static/media/navigation-menu-opened.4815c792.svg";